export default "__VITE_ASSET__51b42eb0__"